<div class="sidebar">
  <nav class="sidebar-nav ps">
    <ul *ngIf="isAuthenticated && (hasUserRoles$ | async)" class="nav">
      <ng-container
        *ngIf="!(hasOnlyTrialDispenserRole$ | async); else trialAccount"
        [ngTemplateOutlet]="menu"
        [ngTemplateOutletContext]="{ items: items }"
      ></ng-container>
      <ng-template #trialAccount>
        <ng-container
          [ngTemplateOutlet]="menu"
          [ngTemplateOutletContext]="{ items: trialAccountItems }"
        ></ng-container>
      </ng-template>
    </ul>
  </nav>
</div>

<ng-template #menu let-items="items">
  <ng-container *ngFor="let item of items; trackBy: trackByFn">
    <li *ngIf="hasPermission(item.permissions)" class="nav-item">
      <a
        href="#"
        class="nav-link"
        [ngClass]="{
          active: isActiveRoute(item.route),
          disabled: item.disabled
        }"
        [routerLink]="item.route"
      >
        <i [ngClass]="item.icon"></i> {{ item.name }}
      </a>
    </li>
  </ng-container>
</ng-template>
